import React, { useEffect, useState } from "react";
import { Table } from "antd";
import JSONData from "../data/data.json";
import "antd/dist/antd.css";
import ScrollAnimation from "react-animate-on-scroll";
import Footer from "../components/Footer";
function Customers(props) {
  const [projects, setProjects] = useState();
  const getProjects = () => {
    setProjects(JSONData.Customers);
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      render: (text) => (
        <ScrollAnimation animateIn="fadeInUp">
          <img src={text} width={100} height={50} />
        </ScrollAnimation>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Description",
      dataIndex: "description",
      align: "left",
    },
    {
      title: "Address",
      dataIndex: "address",
    },
  ];

  useEffect(() => {
    getProjects();
    console.log("Projects: ", projects);
  }, [projects]);

  return (
    <div style={{ backgroundImage: "url(./img/ai1.jpg)" }}>
      <ScrollAnimation animateIn="fadeInRight">
        <img src="./img/ZL_Logo_2023.png" alt="Logo" />
      </ScrollAnimation>

      <Table
        columns={columns}
        dataSource={projects}
        bordered
        title={() => <h1>ZippyLink Customers</h1>}
        footer={() => "The Table may Contain Multiple pages"}
      />
      <Footer />
    </div>
  );
}

export default Customers;
